
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AdministratorPlayersProfileHealthRecordsListFormRemove} from "@/models/app/administrator/players/profile/health-records/list/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "healthRecord",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class AdministratorPlayersProfileHealthRecordsListFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  healthRecord: AdministratorPlayersProfileHealthRecordsListFormRemove = new AdministratorPlayersProfileHealthRecordsListFormRemove();

  formData: AdministratorPlayersProfileHealthRecordsListFormRemove = new AdministratorPlayersProfileHealthRecordsListFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/common/health-record/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getHealthRecords');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.healthRecord;
  }

  resetFormData(): void {
    this.formData = new AdministratorPlayersProfileHealthRecordsListFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
